"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var views = {
    MONTH: 'month',
    YEAR: 'year',
    DECADE: 'decade',
    CENTURY: 'century'
};
exports.directions = {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    UP: 'UP',
    DOWN: 'DOWN'
};
exports.calendarViews = views;
exports.calendarViewHierarchy = {
    month: 'year',
    year: 'decade',
    decade: 'century'
};
exports.calendarViewUnits = {
    month: 'day',
    year: 'month',
    decade: 'year',
    century: 'decade'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/calendar/constants.js
// module id = 523
// module chunks = 0 1 2 3 4 5 6